import generatedProfile from "./profile.generated.json";

const fallbackProfile = {
  name: "Tyler L. Poore",
  brand: "Tyler Poore",
  role: "Technical Support Engineer",
  location: "Suisun City, CA",
  phone: "707-384-5064",
  email: "tylerpoore2000@gmail.com",
  linkedin: "https://linkedin.com/in/tyler-poore-759196107/",
  orcid: "https://orcid.org/0009-0005-1235-6295",
  availability: "Published RFC research on arXiv",
  githubUser: "LiveBacteria",
  githubUrl: "https://github.com/LiveBacteria",
  resumeUrl: "/Tyler_Poore_Bridge_Resume.docx",
  heroHeadline: "Technical Systems Work, Support Operations, and Published RFC Research",
  heroSummary:
    "I work across technical support, systems analysis, QA-minded troubleshooting, and self-directed research. My RFC paper is now published on arXiv.",
  bio: "Technical support and operations professional with systems-thinking and customer-facing debugging experience.",
  stackTools: ["Technical support", "Python", "Git/GitHub"],
  skillGroups: [],
  experience: [],
  education: [],
  rfcResearch: {
    title: "A wave-geometric duality for hyperdimensional computing",
    status: "Published on arXiv, April 23, 2026.",
    summary:
      "Published arXiv paper framing RFC/UWE as a wave-domain realization of HDC/VSA operations. It establishes a unitary map from bipolar hypervectors to coherent broadband waveforms, relates bundling, permutation, binding, and similarity to wave processes, and reports FDTD studies validating array readout and the binding pipeline under realistic propagation.",
    highlights: [],
    source: "a_wave_geometric_duality (1).tex",
    arxivId: "arXiv:2604.22863",
    arxivUrl: "https://arxiv.org/abs/2604.22863",
    pdfUrl: "https://arxiv.org/pdf/2604.22863",
    doiUrl: "https://doi.org/10.48550/arXiv.2604.22863",
    submitted: "April 23, 2026",
    subjects: ["cs.ET", "cs.AR"],
    comments: "26 pages, 2 figures, 3 tables",
  },
  publications: [
    {
      title: "A wave-geometric duality for hyperdimensional computing",
      venue: "arXiv",
      year: "2026",
      status: "Published on arXiv, April 23, 2026.",
      citation:
        "Tyler L. Poore. A wave-geometric duality for hyperdimensional computing. arXiv:2604.22863, 2026.",
      href: "https://arxiv.org/abs/2604.22863",
      doi: "https://doi.org/10.48550/arXiv.2604.22863",
      pdf: "https://arxiv.org/pdf/2604.22863",
      subjects: ["cs.ET", "cs.AR"],
    },
  ],
  contactLinks: [
    {
      label: "LinkedIn",
      icon: "share",
      href: "https://linkedin.com/in/tyler-poore-759196107/",
    },
    {
      label: "ORCID",
      icon: "badge",
      href: "https://orcid.org/0009-0005-1235-6295",
    },
    {
      label: "GitHub",
      icon: "code",
      href: "https://github.com/LiveBacteria",
    },
  ],
};

const profile = {
  ...fallbackProfile,
  ...generatedProfile,
  brand: fallbackProfile.brand,
  availability: fallbackProfile.availability,
  heroHeadline: fallbackProfile.heroHeadline,
  heroSummary: fallbackProfile.heroSummary,
};

export { profile };
